import { Stack, Typography } from "@mui/material";
import { formatDurationInSeconds } from "@entrilia/shared/utilities/formatters";
import StatTile from "../../../../../common/StatTile";
import type {
  InvestorCommunicationEngagementSummary,
  InvestorCommunicationType,
} from "../../../../../../api/types/investorCommunicationsTypes";
import { investorCommunicationEngagementLabels } from "./investorCommunicationEngagementLabels";

interface Props {
  type: InvestorCommunicationType;
  summary: InvestorCommunicationEngagementSummary;
}

const tileSx = { flex: 1 };

const InvestorCommunicationEngagementTiles = ({ type, summary }: Props) => {
  const { avgDepthTitle, avgDepthCaption, avgTimeTitle } = investorCommunicationEngagementLabels[type];
  const { recipientsCount, openedCount, avgCompletionPercentage, avgReadTimeSeconds } = summary;
  const reachPercentage = recipientsCount === 0 ? 0 : Math.round((openedCount * 100) / recipientsCount);

  return (
    <Stack direction="row" spacing={2}>
      <StatTile title="Reach" value={`${openedCount}/${recipientsCount}`} sx={tileSx}>
        <Typography variant="caption" color="textSecondary">
          {reachPercentage}% of recipients
        </Typography>
      </StatTile>
      <StatTile
        title={avgDepthTitle}
        value={avgCompletionPercentage === undefined ? "—" : `${avgCompletionPercentage}%`}
        sx={tileSx}
      >
        <Typography variant="caption" color="textSecondary">
          {avgDepthCaption}
        </Typography>
      </StatTile>
      <StatTile
        title={avgTimeTitle}
        value={avgReadTimeSeconds === undefined ? "—" : formatDurationInSeconds(avgReadTimeSeconds)}
        sx={tileSx}
      >
        <Typography variant="caption" color="textSecondary">
          per reader
        </Typography>
      </StatTile>
    </Stack>
  );
};

export default InvestorCommunicationEngagementTiles;
